import React from 'react';

import {
  DeleteIcon,
  Actions,
  Action,
  VisibilityIcon,
  VisibilityOffIcon,
} from '@gogame/components';

const BulkActionsToolbar = ({
  onBatchShow,
  onBatchHidden,
  onDelete,
  selectedValues,
  disabledHide,
  disabledShow,
}) => {
  return (
    <Actions>
      <Action
        label={'Show'}
        icon={<VisibilityIcon />}
        onClick={(e) => onBatchShow(e, { ids: selectedValues })}
        disabled={disabledShow}
      />
      <Action
        label={'Hide'}
        icon={<VisibilityOffIcon />}
        onClick={(e) => onBatchHidden(e, { ids: selectedValues })}
        disabled={disabledHide}
      />
      <Action
        icon={<DeleteIcon />}
        label={'Delete'}
        onClick={(e) => onDelete(e, { ids: selectedValues })}
      />
    </Actions>
  );
};
export default BulkActionsToolbar;
